module.exports = "https://static.moomoo.com/components/common-redpacket/images/packet-2.5db9e626de.png";